import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import * as imagesLoaded from 'imagesloaded';
import { TweenMax, Power2 } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {pJS} from 'particles.js';
gsap.registerPlugin(ScrollTrigger);


export function index(){

  gsap.fromTo(
    '#headbar',
    {
      width: 0,
    },
    {
      width: '100%',
      duration: 1,
      scrollTrigger: {
        ease: Power2.easeIn,
        trigger: '#site-wrapper',
        start: "top top",
        end: "bottom bottom",
        scrub: 2,
        //markers: true
      },
    }
  )


  const scrolEvents = document.querySelectorAll(".scroll-event")
  scrolEvents.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      //markers: true,
      start: "top bottom",
      end: "bottom top",
      once: true,
      toggleClass: {targets: el, className: "active"},
    });
  })

  const scrolAddEvents = document.querySelectorAll(".scroll-add-event")
  scrolAddEvents.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      //markers: true,
      start: "top bottom",
      end: "bottom top",
      once: true,
      toggleClass: {targets: el, className: "active"},
    });
  })


  const circleTxt = document.getElementById('circleTxt')
  gsap.fromTo(
    circleTxt,
    {
      y: '0%',
    },
    {
      y: '50%',
      duration: 1,
      scrollTrigger: {
        ease: Power2.easeIn,
        trigger: '.fifth',
        start: "top bottom",
        end: "bottom center",
        scrub: 1,
        //markers: true
      },
    }
  )

  const circleCloud = document.getElementById('circleCloud')
  gsap.fromTo(
    circleCloud,
    {
      top: '-5%',
      left: '-30%',
    },
    {
      top: '5%',
      left: '-5%',
      duration: 1,
      scrollTrigger: {
        ease: Power2.easeIn,
        trigger: '.fifth',
        start: "top bottom",
        end: "bottom center",
        scrub: 2,
        //markers: true
      },
    }
  )

};